module.exports = __webpack_public_path__ + "static/media/temple.7182e974.webp";